var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"engage-loader",class:{
		'engage-loader--overlay': _vm.overlay,
		'engage-loader--inline': _vm.inline,
	},attrs:{"aria-busy":"true","aria-live":_vm.ariaLive,"role":"status"}},[_c('div',{staticClass:"engage-loader__spinner"}),_c('h3',{staticClass:"engage-loader__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }